import Endpoints from "../constants/Endpoints";
import {RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from "../redux/store";
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";

const showError = (message) => {
	reduxStore.dispatch(setSaveStatusError(message))
}

const getFilesAdnFolders = async (demandId, folderPath) => {
	let params = {
		folderPath
	}
	try {
		const resp = await RestRequestGET(Endpoints.SHAREPOINT(demandId), {params});
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}

	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const downloadFileFromSharepoint = async (demandId, file) => {
	try {
		return await RestRequestPOST(Endpoints.SHAREPOINT(demandId), file);
	} catch (e) {
		console.error(e);
	}
	return {uploadStatus: "ERROR"}
}

export default {
	getFilesAdnFolders,
	downloadFileFromSharepoint
};

